import { useTranslation } from 'react-i18next'
import isObject from 'lodash-es/isObject'

import Button from '../../Button'
import { Divider } from '../../Divider'
import { useSelectContext } from '../Select.hooks'

import * as styles from './SelectDropdownListFooter.module.css'

function SelectDropdownListFooter({
  Element = 'div',
  className = styles.SelectDropdownListFooter,
}) {
  const { t } = useTranslation()

  const { handleToggleShowSelected, multi, showSelected, value } =
    useSelectContext()

  return multi && isObject(value) && value.length > 0 ? (
    <Element className={className}>
      <Divider />
      <Button.Text
        className={styles.showSelectedButton}
        text={t(
          showSelected
            ? 'Common.SelectDropdownListShowAllButtonTextKey'
            : 'Common.SelectDropdownListShowOnlySelectedButtonTextKey'
        )}
        onClick={handleToggleShowSelected}
      />
    </Element>
  ) : null
}

export default SelectDropdownListFooter
